<template>
  <b-table
    bordered
    show-empty
    class="admin-table"
    :items="surveys"
    :fields="fields"
    :busy="isBusy"
  >
    <template slot="empty" v-if="emptyMessage">
      <div role="alert" aria-live="polite">
        <div class="text-center my-2">{{ emptyMessage }}</div>
      </div>
    </template>
    <template slot="details" slot-scope="{ item }">
      <div>Convenience {{ getStudyConvenienceValue(item) }}%</div>
      <div>Random: {{ getStudyRandomValue(item) }}%</div>
      <div>
        <b-btn
          v-if="parseInt(item.is_support_report) === 1"
          variant="primary"
          :to="`/view-admin-results/${item.id}`"
        >
          View Reports
        </b-btn>
      </div>
    </template>
    <template slot="table-busy">
      <div>
        <HalfCircleSpinner />
        <div class="spinner-message my-3 text-center">Loading the data...</div>
      </div>
    </template>
  </b-table>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';
import { loadFromStorage, saveToStorage } from '@/helpers/localStorageHelper';
export default {
  name: 'CompletedSurveys',
  components: {
    HalfCircleSpinner,
  },
  props: {
    isGmAdminType: {
      type: Boolean,
      default: false,
    },
    surveys: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
    },
  },
  computed: {
    fields: function () {
      return [
        {
          key: 'survey',
          label: 'Study Name',
          formatter: (value, key, item) => item.title,
          class: 'text-center',
        },
        {
          key: 'membershipType',
          label: 'Memberships',
          class: 'text-center',
          formatter: (value, key, item) => {
            const typeList = item.societyMembershipTypes.reduce(
              (types, { type_name }) => {
                types.push(type_name);
                return types;
              },
              []
            );
            return typeList.join(', ');
          },
        },
        {
          key: 'period',
          label: 'Period',
          class: 'text-center',
          formatter: (value, key, item) =>
            `${this.$dayjs(item.start_date).format(
              'MM/DD/YYYY'
            )} - ${this.$dayjs(item.end_date).format('MM/DD/YYYY')}`,
        },
        {
          key: 'open_close_date',
          label: 'Open/Close Date',
          class: 'text-center',
          formatter: (value, key, item) =>
            `${this.$dayjs(item.active_date).format(
              'MM/DD/YYYY'
            )} - ${this.$dayjs(item.completion_date).format('MM/DD/YYYY')}`,
        },
        { key: 'details', class: 'text-center' },
      ];
    },
    isDemoMode: function () {
      return this.$store.getters.isDemoMode;
    },
  },
  methods: {
    getStudyConvenienceValue: function (study) {
      if (this.isDemoMode) {
        const key = `study-convenience-${study.id}`;
        let value = loadFromStorage(key);
        if (!value || value < 45 || value > 75) {
          value = Math.floor(Math.random() * (75 - 45 + 1)) + 45;
          saveToStorage(key, value);
        }
        return value;
      }
      return study.status.convenienceParticipationPercentage || 0;
    },
    getStudyRandomValue: function (study) {
      if (this.isDemoMode) return 0;
      return study.status.randomParticipationPercentage || 0;
    }
  },
};
</script>
